/* SeeMy — page formation (style vitrine WordPress) :
   révélations au défilement, onglets accessibles, vidéo avec pause,
   frise verticale avec scrollspy, formulaire de fiche en 2 étapes. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function headerOffset() {
    var cands = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .shopify-section-header-sticky, .section-header, header');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i], cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.height < 260) return Math.round(r.height);
      }
    }
    return 24;
  }

  function initReveal(root) {
    var els = root.querySelectorAll('[data-sf-reveal],[data-sf-spin]');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-sf-tabs]').forEach(function (box) {
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role=tab]'));
      function select(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) t.focus();
        if (t.scrollIntoView && window.innerWidth < 750) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  function initVideo(root) {
    root.querySelectorAll('.sf-tech__media--video').forEach(function (box) {
      var v = box.querySelector('video'), b = box.querySelector('[data-sf-video-toggle]');
      if (!v || !b) return;
      v.muted = true; v.setAttribute('aria-hidden', 'true'); v.removeAttribute('controls');
      function sync() {
        var paused = v.paused;
        b.setAttribute('aria-pressed', paused ? 'true' : 'false');
        b.setAttribute('aria-label', paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
      }
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); } else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      b.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
      v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
    });
  }

  function initTimeline(root) {
    root.querySelectorAll('[data-sf-timeline]').forEach(function (tl) {
      var fill = tl.querySelector('.sf-timeline__fill');
      var line = tl.querySelector('.sf-timeline__line');
      var steps = Array.prototype.slice.call(tl.querySelectorAll('[data-sf-step]'));
      var section = tl.closest('.sf-steps');
      var links = section ? Array.prototype.slice.call(section.querySelectorAll('[data-sf-spy-link]')) : [];
      var ticking = false;

      function update() {
        ticking = false;
        var mid = window.innerHeight * 0.55;
        var lr = line.getBoundingClientRect();
        var h = Math.max(0, Math.min(lr.height, mid - lr.top));
        fill.style.height = h + 'px';
        var active = -1;
        steps.forEach(function (s, i) {
          var d = s.querySelector('.sf-step__dot').getBoundingClientRect();
          if (d.top + d.height / 2 <= mid) active = i;
        });
        steps.forEach(function (s, i) {
          s.classList.toggle('is-active', i === active);
          s.classList.toggle('is-done', i < active);
        });
        links.forEach(function (a, i) {
          var on = i === active;
          a.classList.toggle('is-active', on);
          if (on) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
        });
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();

      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var t = document.querySelector(a.getAttribute('href'));
          if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          var card = t.querySelector('.sf-step__card');
          if (card) { card.setAttribute('tabindex', '-1'); card.focus({ preventScroll: true }); }
        });
      });
    });
  }

  function initStepsForm(root) {
    root.querySelectorAll('[data-sf-steps-form] form.sm-optin').forEach(function (form) {
      var fields = form.querySelector('.sm-optin__fields');
      var consent = form.querySelector('.sm-optin__consent');
      var submit = form.querySelector('button[type=submit]');
      var legal = form.querySelector('.sm-optin__legal');
      if (!fields || !consent || !submit) return;

      var prog = document.createElement('div');
      prog.className = 'sf-progress';
      prog.setAttribute('aria-hidden', 'true');
      prog.innerHTML = '<span class="is-on">1</span><i></i><span>2</span>';
      var live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');

      var p1 = document.createElement('div'); p1.setAttribute('data-sf-pane', '1');
      var p2 = document.createElement('div'); p2.setAttribute('data-sf-pane', '2'); p2.hidden = true;
      form.insertBefore(prog, fields);
      form.insertBefore(live, fields);
      form.insertBefore(p1, fields);
      p1.appendChild(fields);
      var nav1 = document.createElement('div'); nav1.className = 'sf-stepnav';
      var next = document.createElement('button'); next.type = 'button'; next.className = 'sm-optin__btn'; next.textContent = 'Suivant';
      nav1.appendChild(next); p1.appendChild(nav1);

      form.insertBefore(p2, p1.nextSibling);
      p2.appendChild(consent);
      var nav2 = document.createElement('div'); nav2.className = 'sf-stepnav';
      var back = document.createElement('button'); back.type = 'button'; back.className = 'sm-optin__btn sf-back'; back.textContent = 'Retour';
      nav2.appendChild(back); nav2.appendChild(submit); p2.appendChild(nav2);
      if (legal) p2.appendChild(legal);

      function setStep(n) {
        p1.hidden = n !== 1; p2.hidden = n !== 2;
        prog.children[2].classList.toggle('is-on', n === 2);
        prog.style.setProperty('--sf-prog', n === 2 ? 1 : 0);
        live.textContent = 'Étape ' + n + ' sur 2';
        var first = (n === 1 ? p1 : p2).querySelector('input,select');
        if (first) first.focus();
      }
      function status(msg) { var st = form.querySelector('.sm-optin__status'); if (st) { st.textContent = msg; st.classList.toggle('is-error', !!msg); } }
      function validate1() {
        var bad = null;
        ['first_name', 'last_name', 'email'].forEach(function (n) {
          var el = form.elements[n]; if (!el) return;
          var v = el.value.trim();
          var ok = n === 'email' ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) : v.length > 0;
          if (ok) el.removeAttribute('aria-invalid'); else { el.setAttribute('aria-invalid', 'true'); if (!bad) bad = el; }
        });
        if (bad) { status('Merci de compléter vos coordonnées (prénom, nom et e-mail valide).'); bad.focus(); return false; }
        status(''); return true;
      }
      next.addEventListener('click', function () { if (validate1()) setStep(2); });
      back.addEventListener('click', function () { status(''); setStep(1); });
      // Entrée à l'étape 1 : passer à l'étape 2 au lieu d'envoyer
      document.addEventListener('submit', function (e) {
        if (e.target === form && !p1.hidden) { e.preventDefault(); e.stopImmediatePropagation(); if (validate1()) setStep(2); }
      }, true);
      // Envoi réussi : on n'affiche plus que le message de confirmation
      new MutationObserver(function () {
        if (form.classList.contains('is-done')) { p1.hidden = true; p2.hidden = true; prog.hidden = true; }
      }).observe(form, { attributes: true, attributeFilter: ['class'] });
      prog.style.setProperty('--sf-prog', 0);
    });
  }

  function boot() {
    document.querySelectorAll('.sf').forEach(function (root) {
      root.classList.add('sf-js');
      root.style.setProperty('--sf-top', headerOffset() + 'px');
      initReveal(root); initTabs(root); initVideo(root); initTimeline(root); initStepsForm(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
